"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Vue } from "vue-property-decorator";
import Register from "./Register.vue";
import MainLayout from "../MainLayout.vue";
let RegisterDiscard = class extends Vue {
  constructor() {
    super(...arguments);
    this.formStatus = "login";
    this.isWeiXin = false;
  }
  mounted() {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-10780347409/9l-zCNzSuPsCEJGYvJQo"
      });
    }
    this.isInWechatMP();
  }
  download(platform) {
    if (platform === "windows") {
    }
    if (platform === "macIntel") {
    }
    if (platform === "macM1") {
    }
  }
  toDownload() {
    window.open("https://www.kuajingvs.com/download", "_self");
  }
  isInWechatMP() {
    const array = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    const userAgent = navigator.userAgent;
    let flag = false;
    for (let i = 0; i < array.length; i++) {
      if (userAgent.indexOf(array[i]) > 0) {
        flag = true;
        break;
      }
    }
    if (flag) {
      document.getElementsByTagName("body")[0].style.minWidth = "0";
      document.getElementsByTagName("html")[0].style.minWidth = "0";
      document.getElementById("app").style.minWidth = "0";
      document.getElementsByTagName("body")[0].style.backgroundColor = "#ffffff";
      document.getElementById("app").style.backgroundColor = "#ffffff";
      this.isWeiXin = true;
    } else {
      document.getElementsByTagName("body")[0].style.backgroundColor = "#ffffff";
      document.getElementById("app").style.backgroundColor = "#ffffff";
      document.getElementsByTagName("section")[0].style.backgroundColor = "#ffffff";
      this.isWeiXin = false;
    }
  }
};
RegisterDiscard = __decorateClass([
  Component({
    components: {
      Register,
      MainLayout
    }
  })
], RegisterDiscard);
export {
  RegisterDiscard as default
};
